module.exports = __webpack_public_path__ + "img/daohangtuxiao.03455f67.png";